/**
 * `/$tenantSlug/settings/fields` — the company's choices about its fields
 * (SS-B8-T1, ADR-0275 point 6).
 *
 * The page itself is `components/FieldsSettings.tsx`, imported on demand: this
 * file holds only the route and its permission gate, so a visitor who never
 * opens Settings → Fields never downloads it (the split Settings → Lists makes).
 * The gate is outside the lazy boundary, so somebody who may not open the page
 * does not download it to be told so. Changes additionally need
 * `shell.settings.edit`, checked inside the page and by the API.
 */

import { RequirePermission } from "@ken/auth";
import { Skeleton } from "@ken/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy, type ReactElement } from "react";

const FieldsSettingsContent = lazy(async () => import("../components/FieldsSettings"));

export const Route = createFileRoute("/$tenantSlug/settings/fields")({
  component: FieldsSettingsRoute,
});

function FieldsSettingsRoute(): ReactElement {
  return (
    <RequirePermission slug="shell.settings.view">
      <Suspense fallback={<Skeleton className="h-40 w-full" />}>
        <FieldsSettingsContent />
      </Suspense>
    </RequirePermission>
  );
}
